import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, Optional, ɵɵdirectiveInject, ɵɵdefineComponent, Component, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, SkipSelf } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap, catchError, switchMap, filter, take } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { LocalService } from '@akeela/local-storage';
import * as jwt_decode_ from 'jwt-decode';
import { PathService } from '@akeela/properties';
import { AuthService as AuthService$1 } from '@akeela/auth';
import { __decorate, __param, __metadata } from 'tslib';

class SecurityConfigConst {
}
SecurityConfigConst.urlApi = 'http://localhost:8181';
SecurityConfigConst.urlFront = 'http://localhost:4300';
SecurityConfigConst.clientCode = 'TEST_CLIENT';
SecurityConfigConst.uriLogin = 'security/login';
SecurityConfigConst.uriLogout = 'security/logout';
SecurityConfigConst.uriForgotPassword = 'security/forgot-password';
SecurityConfigConst.uriRefreshToken = 'refresh';
SecurityConfigConst.urlSecurityApi = 'http://localhost:8181';
SecurityConfigConst.encryptLocalStorage = false;
SecurityConfigConst.encryptLocalStorageSecretKey = '$rhbfwbrh4455.222.2jdfbsdhfKtttp#ajsdfjasdfajsd%ghhguhtughtuhguthgu3456-ahsbdhfbashdbfhabsdhfbahsdbf2y4587t48rg23b4hbrfu8g2382y4gr2yug347trf23ytr4vy2uv2uy3vfy23v4ry825ut2brf';

class SecurityConfig {
}

class SecurityConfigService {
    constructor(config) {
        this.kaadConfig = new SecurityConfig();
        if (config) {
            this.options = config;
        }
    }
    set options(opt) {
        this.kaadConfig.urlApi = (opt && opt.urlApi) ? opt.urlApi : SecurityConfigConst.urlApi;
        this.kaadConfig.urlFront = (opt && opt.urlFront) ? opt.urlFront : SecurityConfigConst.urlFront;
        this.kaadConfig.clientCode = (opt && opt.clientCode) ? opt.clientCode : SecurityConfigConst.clientCode;
        this.kaadConfig.uriLogin = (opt && opt.uriLogin) ? opt.uriLogin : SecurityConfigConst.uriLogin;
        this.kaadConfig.uriLogout = (opt && opt.uriLogout) ? opt.uriLogout : SecurityConfigConst.uriLogout;
        this.kaadConfig.uriForgotPassword = (opt && opt.uriForgotPassword) ? opt.uriForgotPassword : SecurityConfigConst.uriForgotPassword;
        this.kaadConfig.uriRefreshToken = (opt && opt.uriRefreshToken) ? opt.uriRefreshToken : SecurityConfigConst.uriRefreshToken;
        this.kaadConfig.urlSecurityApi = (opt && opt.urlSecurityApi) ? opt.urlSecurityApi : SecurityConfigConst.urlSecurityApi;
        this.kaadConfig.encryptLocalStorage = (opt && opt.encryptLocalStorage) ? opt.encryptLocalStorage : SecurityConfigConst.encryptLocalStorage;
        this.kaadConfig.encryptLocalStorageSecretKey = (opt && opt.encryptLocalStorageSecretKey) ? opt.encryptLocalStorageSecretKey : SecurityConfigConst.encryptLocalStorageSecretKey;
    }
    get urlApi() {
        return this.kaadConfig.urlApi;
    }
    get urlFront() {
        return this.kaadConfig.urlFront;
    }
    get clientCode() {
        return this.kaadConfig.clientCode;
    }
    get uriLogin() {
        return this.kaadConfig.uriLogin;
    }
    get uriLogout() {
        return this.kaadConfig.uriLogout;
    }
    get uriForgotPassword() {
        return this.kaadConfig.uriForgotPassword;
    }
    get uriRefreshToken() {
        return this.kaadConfig.uriRefreshToken;
    }
    get urlSecurityApi() {
        return this.kaadConfig.urlSecurityApi;
    }
    get urlFullRefreshToken() {
        return `${this.urlSecurityApi}/${this.uriRefreshToken}`;
    }
    getEncryptLocalStorage() {
        return this.kaadConfig.encryptLocalStorage;
    }
    getEncryptLocalStorageSecretKey() {
        return this.kaadConfig.encryptLocalStorageSecretKey;
    }
}
/** @nocollapse */ SecurityConfigService.ɵfac = function SecurityConfigService_Factory(t) { return new (t || SecurityConfigService)(ɵɵinject(SecurityConfig, 8)); };
/** @nocollapse */ SecurityConfigService.ɵprov = ɵɵdefineInjectable({ token: SecurityConfigService, factory: SecurityConfigService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SecurityConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: SecurityConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();

let url;
class SecurityService {
    constructor(localStorage, http, config) {
        this.localStorage = localStorage;
        this.http = http;
        this.config = config;
        url = this.config.urlApi + 'auth';
    }
    validateAuthorizationCode(clientCode, code) {
        const authorizationUrl = `${url}/accessToken?clientCode=${clientCode}&code=${code}`;
        return this.http.post(authorizationUrl, {});
    }
    validateAccessToken() {
        return new Observable(subscriber => {
            const token = this.localStorage.getItem('access-token');
            if (isNullOrUndefined(token)) {
                subscriber.next(false);
                subscriber.complete();
            }
            else {
                const validateTokenUrl = `${url}/accessToken?token=${token}&clientCode=${this.config.clientCode}`;
                console.log(validateTokenUrl);
                this.http.get(validateTokenUrl).subscribe(response => {
                    subscriber.next(response.valid);
                    subscriber.complete();
                }, error => {
                    console.log('error: ', error);
                    subscriber.next(false);
                    subscriber.complete();
                });
            }
        });
    }
}
/** @nocollapse */ SecurityService.ɵfac = function SecurityService_Factory(t) { return new (t || SecurityService)(ɵɵinject(LocalService), ɵɵinject(HttpClient), ɵɵinject(SecurityConfigService)); };
/** @nocollapse */ SecurityService.ɵprov = ɵɵdefineInjectable({ token: SecurityService, factory: SecurityService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SecurityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LocalService }, { type: HttpClient }, { type: SecurityConfigService }]; }, null); })();

const jwt_decode = jwt_decode_;
class AuthService {
    constructor(config, http, path, securityService, localStorage) {
        this.config = config;
        this.http = http;
        this.path = path;
        this.securityService = securityService;
        this.localStorage = localStorage;
        this.renewingToken = false;
        this.refreshToken$ = new BehaviorSubject(null);
        this.refreshTokenSubject = this.refreshToken$.asObservable();
    }
    get token() { return this.localStorage.getItem('access-token'); }
    set token(jwtToken) {
        this.localStorage.setItem('access-token', jwtToken);
        // si estamos refrescando el token, avisamos a los observadores
        if (this.refreshTokenInProgress) {
            this.refreshToken$.next(jwtToken);
        }
    }
    get isLoggedIn() {
        if (isNullOrUndefined(this.localStorage.getItem('access-token'))) {
            console.log('no hay token', isNullOrUndefined(this.localStorage.getItem('access-token')));
            return false;
        }
        return true;
    }
    get isLoggedIn$() {
        return new Observable(subscriber => {
            if (isNullOrUndefined(this.localStorage.getItem('access-token'))) {
                subscriber.next(false);
                subscriber.complete();
            }
            else {
                this.validateToken().subscribe(valid => subscriber.next(valid), () => subscriber.next(false), () => subscriber.complete());
            }
        });
    }
    /**
     * setter y getter para el estado del progreso del refrescamiento del token
     */
    get refreshTokenInProgress() { return this.renewingToken; }
    set refreshTokenInProgress(value) {
        this.refreshToken$.next(null);
        this.renewingToken = value;
    }
    getUsername() {
        let username = null;
        const token = this.token;
        if (!isNullOrUndefined(token)) {
            const decoded = jwt_decode(token);
            if (decoded.sub === '') {
                return '';
            }
            username = decoded.sub;
        }
        return username;
    }
    handleLogout() {
        this.localStorage.clear();
    }
    logout() {
        return new Observable(resolve => {
            const logoutName = 'person$logout$delete';
            this.path.getPathService(logoutName).subscribe(response => {
                const username = this.getUsername();
                const params = { username };
                const url = response.url;
                this.http.delete(url, { params }).subscribe(responseLogout => {
                    this.handleLogout();
                    resolve.next(responseLogout);
                    resolve.complete();
                }, error => {
                    this.handleLogout();
                    resolve.next(error);
                    resolve.complete();
                });
            });
        });
    }
    /**
     * gestiona los errores de conexión ocurridos en las solicitudes de seguridad
     * @param error error.
     */
    errorHandle(error) {
        // hacer algo con el error, enviar una notificación o algo
        return throwError(error);
    }
    handleRenewToken(response) {
        if (isNullOrUndefined(response) || isNullOrUndefined(response.token)) {
            this.deleteAllToken();
        }
        else {
            this.token = response.token;
        }
        this.refreshTokenInProgress = false;
    }
    renewToken() {
        // renovamos el token utilizando el refresh token
        this.refreshTokenInProgress = true;
        const url = this.config.urlFullRefreshToken;
        const body = {
            'refresh-token': this.localStorage.getItem('refresh-token')
        };
        return this.http.get(url).pipe(tap(response => this.handleRenewToken(response)), catchError(error => {
            this.refreshTokenInProgress = false;
            return this.errorHandle(error);
        }));
    }
    validateToken() {
        return this.securityService.validateAccessToken();
    }
    /**
     * elimina el access token del localstorage
     */
    deleteToken() {
        this.localStorage.removeItem('access-token');
    }
    /**
     * elimina el refresh token del localstorage
     */
    deleteRefreshToken() {
        this.localStorage.removeItem('refresh-token');
    }
    /**
     * elimina todos los token, tanto el access token como el refresh token
     */
    deleteAllToken() {
        this.deleteToken();
        this.deleteRefreshToken();
    }
}
/** @nocollapse */ AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵɵinject(SecurityConfigService), ɵɵinject(HttpClient), ɵɵinject(PathService), ɵɵinject(SecurityService), ɵɵinject(LocalService)); };
/** @nocollapse */ AuthService.ɵprov = ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: SecurityConfigService }, { type: HttpClient }, { type: PathService }, { type: SecurityService }, { type: LocalService }]; }, null); })();

class AuthGuard {
    constructor(authService, config, router) {
        this.authService = authService;
        this.config = config;
        this.router = router;
    }
    canActivate(next, state) {
        return new Observable(subscriber => {
            this.authService.isLoggedIn$.subscribe(valid => {
                if (!valid) {
                    this.router.navigate([this.config.uriLogin]);
                }
                subscriber.next(valid);
            }, () => {
                this.router.navigate([this.config.uriLogin]);
                subscriber.next(false);
            }, () => subscriber.complete());
        });
    }
}
/** @nocollapse */ AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵɵinject(AuthService), ɵɵinject(SecurityConfigService), ɵɵinject(Router)); };
/** @nocollapse */ AuthGuard.ɵprov = ɵɵdefineInjectable({ token: AuthGuard, factory: AuthGuard.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AuthService }, { type: SecurityConfigService }, { type: Router }]; }, null); })();

class HttpInterceptorService {
    constructor(authService, config, router, localStorage) {
        this.authService = authService;
        this.config = config;
        this.router = router;
        this.localStorage = localStorage;
    }
    addToken(request, token) {
        return request.clone({
            setHeaders: { Authorization: `${token}` }
        });
    }
    validUrl(url) {
        return url.indexOf(`${this.config.urlSecurityApi}/log_out`) === -1
            && url.indexOf(`${this.config.urlSecurityApi}/login`) === -1;
    }
    intercept(request, next) {
        // console.log("entro al intercept");
        let token;
        if (request.url.indexOf('refresh') >= 0) {
            token = this.localStorage.getItem('refresh-token');
        }
        else {
            token = this.localStorage.getItem('access-token');
        }
        if (token) {
            request = this.addToken(request, token);
        }
        // Mario: Se comento porque esto genera un error al subir archivos, debido a que setea un content-type como json, cuando la petición es multipart, y no se puede forzar enviar ese content-type.
        // if (!request.headers.has('Content-Type')) {
        //     request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        // }
        // Juan: Se comento nuevamento porque el Accept ya se envia automatico desde los sevicios 
        // request = request.clone({ headers: request.headers.set('Accept', 'application/ak.security.app+json') });
        const response = next.handle(request).pipe(catchError((error) => {
            var _a;
            console.log('error en : ', request.url);
            console.log(error);
            if (request.url === this.config.urlFullRefreshToken) {
                this.authService.logout().subscribe(response => {
                    this.router.navigate([this.config.uriLogout]);
                });
                return throwError(error);
            }
            else if ((error.status === 401 || error.status === 403) && this.validUrl(request.url)) {
                this.handle403Error(request, next);
                return throwError(error);
            }
            else {
                if ((error.status === 406)) {
                    if (error.error) {
                        let data = JSON.parse(error.error);
                        if ((_a = data === null || data === void 0 ? void 0 : data.message) === null || _a === void 0 ? void 0 : _a.includes('JWT expired')) {
                            this.router.navigate([this.config.uriLogout]);
                        }
                    }
                }
                else {
                    return throwError(error);
                }
            }
        }));
        return response;
    }
    handle403Error(request, next) {
        if (!this.authService.refreshTokenInProgress) {
            return this.authService.renewToken().pipe(switchMap(() => next.handle(this.addToken(request, this.authService.token))));
        }
        else {
            return this.authService.refreshTokenSubject.pipe(filter(token => token !== null), take(1), switchMap(token => next.handle(this.addToken(request, token))));
        }
    }
}
/** @nocollapse */ HttpInterceptorService.ɵfac = function HttpInterceptorService_Factory(t) { return new (t || HttpInterceptorService)(ɵɵinject(AuthService), ɵɵinject(SecurityConfigService), ɵɵinject(Router), ɵɵinject(LocalService)); };
/** @nocollapse */ HttpInterceptorService.ɵprov = ɵɵdefineInjectable({ token: HttpInterceptorService, factory: HttpInterceptorService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HttpInterceptorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AuthService }, { type: SecurityConfigService }, { type: Router }, { type: LocalService }]; }, null); })();

class LoginComponent {
    constructor(config) {
        this.config = config;
    }
    ngOnInit() {
        window.location.href = this.config.urlApi + '/auth/authorize?clientCode=' + this.config.clientCode;
    }
}
/** @nocollapse */ LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(ɵɵdirectiveInject(SecurityConfigService)); };
/** @nocollapse */ LoginComponent.ɵcmp = ɵɵdefineComponent({ type: LoginComponent, selectors: [["akeela-login"]], decls: 0, vars: 0, template: function LoginComponent_Template(rf, ctx) { }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-login',
                templateUrl: './login.component.html',
                styleUrls: ['./login.component.scss']
            }]
    }], function () { return [{ type: SecurityConfigService }]; }, null); })();

class LogoutComponent {
    constructor(authService, config) {
        this.authService = authService;
        this.config = config;
    }
    ngOnInit() {
        this.authService.logout().subscribe(() => {
            window.location.href = this.config.urlApi + '/auth/authorize?clientCode=' + this.config.clientCode;
        });
    }
}
/** @nocollapse */ LogoutComponent.ɵfac = function LogoutComponent_Factory(t) { return new (t || LogoutComponent)(ɵɵdirectiveInject(AuthService), ɵɵdirectiveInject(SecurityConfigService)); };
/** @nocollapse */ LogoutComponent.ɵcmp = ɵɵdefineComponent({ type: LogoutComponent, selectors: [["akeela-logout"]], decls: 0, vars: 0, template: function LogoutComponent_Template(rf, ctx) { }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LogoutComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-logout',
                templateUrl: './logout.component.html',
                styleUrls: ['./logout.component.scss']
            }]
    }], function () { return [{ type: AuthService }, { type: SecurityConfigService }]; }, null); })();

class ValidateAuthCodeComponent {
    constructor(activatedRoute, config, router, securityService) {
        this.activatedRoute = activatedRoute;
        this.config = config;
        this.router = router;
        this.securityService = securityService;
    }
    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            let clientCode;
            let code;
            if (!isNullOrUndefined(params.clientCode) && params.clientCode === this.config.clientCode) {
                clientCode = params.clientCode;
            }
            if (!isNullOrUndefined(params.code)) {
                code = params.code;
            }
            this.securityService.validateAuthorizationCode(clientCode, code).subscribe((response) => {
                console.log("validateAuthorizationCode");
                /*  localStorage.setItem('access-token', response['access-token']);
                  localStorage.setItem('refresh-token', response['refresh-token']);
  
                  this.router.navigate(['/']);*/
            });
        });
    }
}
/** @nocollapse */ ValidateAuthCodeComponent.ɵfac = function ValidateAuthCodeComponent_Factory(t) { return new (t || ValidateAuthCodeComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(SecurityConfigService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(SecurityService)); };
/** @nocollapse */ ValidateAuthCodeComponent.ɵcmp = ɵɵdefineComponent({ type: ValidateAuthCodeComponent, selectors: [["akeela-validate-auth-code"]], decls: 0, vars: 0, template: function ValidateAuthCodeComponent_Template(rf, ctx) { }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ValidateAuthCodeComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-validate-auth-code',
                templateUrl: './validate-auth-code.component.html',
                styleUrls: ['./validate-auth-code.component.scss']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: SecurityConfigService }, { type: Router }, { type: SecurityService }]; }, null); })();

class JwtInterceptor {
    constructor(_auth, localStorage) {
        this._auth = _auth;
        this.localStorage = localStorage;
    }
    intercept(request, next) {
        if (this._auth.isTokenExpired() === 2 && this.localStorage.getItem('activate_validation') !== 'true') {
            this.localStorage.setItem('activate_validation', 'true');
            this._auth.set_detect_exp_jwt();
        }
        else if (this._auth.isTokenExpired() === 3) {
            // this._auth.logout();
        }
        const currentUser = JSON.parse(this.localStorage.getItem('token'));
        if (currentUser && currentUser.token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `${currentUser.token}`
                }
            });
        }
        else {
        }
        return next.handle(request);
    }
}
/** @nocollapse */ JwtInterceptor.ɵfac = function JwtInterceptor_Factory(t) { return new (t || JwtInterceptor)(ɵɵinject(AuthService$1), ɵɵinject(LocalService)); };
/** @nocollapse */ JwtInterceptor.ɵprov = ɵɵdefineInjectable({ token: JwtInterceptor, factory: JwtInterceptor.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(JwtInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthService$1 }, { type: LocalService }]; }, null); })();

class JwtRefreshInterceptor {
    constructor(_auth, localStorage) {
        this._auth = _auth;
        this.localStorage = localStorage;
    }
    intercept(request, next) {
        if (this._auth.isTokenExpired() === 2 && this.localStorage.getItem('activate_validation') !== 'true') {
            this.localStorage.setItem('activate_validation', 'true');
            this._auth.set_detect_exp_jwt();
        }
        else if (this._auth.isTokenExpired() === 3) {
            // this._auth.logout();
        }
        const currentUser = JSON.parse(this.localStorage.getItem('token'));
        if (currentUser && currentUser.token) {
            request = request.clone({
                setHeaders: {
                    Authorization: ` ${currentUser.token}`
                }
            });
        }
        else {
        }
        return next.handle(request);
    }
}
/** @nocollapse */ JwtRefreshInterceptor.ɵfac = function JwtRefreshInterceptor_Factory(t) { return new (t || JwtRefreshInterceptor)(ɵɵinject(AuthService$1), ɵɵinject(LocalService)); };
/** @nocollapse */ JwtRefreshInterceptor.ɵprov = ɵɵdefineInjectable({ token: JwtRefreshInterceptor, factory: JwtRefreshInterceptor.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(JwtRefreshInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthService$1 }, { type: LocalService }]; }, null); })();

class AkeelaSecurityModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('SecurityModule is already loaded. Import it in the AppModule only');
        }
    }
    static config(config) {
        return {
            ngModule: AkeelaSecurityModule,
            providers: [
                { provide: SecurityConfig, useValue: config }
            ]
        };
    }
}
/** @nocollapse */ AkeelaSecurityModule.ɵmod = ɵɵdefineNgModule({ type: AkeelaSecurityModule });
/** @nocollapse */ AkeelaSecurityModule.ɵinj = ɵɵdefineInjector({ factory: function AkeelaSecurityModule_Factory(t) { return new (t || AkeelaSecurityModule)(ɵɵinject(AkeelaSecurityModule, 12)); }, imports: [[]] });
__decorate([
    __param(0, Optional()),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SecurityConfig]),
    __metadata("design:returntype", Object)
], AkeelaSecurityModule, "config", null);
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AkeelaSecurityModule, { declarations: [ValidateAuthCodeComponent,
        LoginComponent,
        LogoutComponent], exports: [ValidateAuthCodeComponent,
        LoginComponent,
        LogoutComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaSecurityModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [
                    ValidateAuthCodeComponent,
                    LoginComponent,
                    LogoutComponent
                ],
                exports: [
                    ValidateAuthCodeComponent,
                    LoginComponent,
                    LogoutComponent
                ]
            }]
    }], function () { return [{ type: AkeelaSecurityModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

/*
 * Public API Surface of akeela-security
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AkeelaSecurityModule, AuthGuard, AuthService, HttpInterceptorService, JwtInterceptor, JwtRefreshInterceptor, LoginComponent, LogoutComponent, SecurityService, ValidateAuthCodeComponent };
//# sourceMappingURL=akeela-security.js.map
